import { createUseStyles } from 'react-jss'
import { smallPhonesDown } from '../../../../../styles/const/breakpoints'

const useStyles = createUseStyles({
  cardsList: {
    display: 'grid',
    width: '100%',
    padding: '20px 16px 20px 18px',
    gridGap: 16,
    gridTemplateColumns: 'repeat(auto-fill, [col-start] minmax(320px, 1fr) [col-end])'
  },
  adPreviewWrapper: {
    minHeight: 130,
    padding: '0 8px'
  },
  facebookAdPreviewWrapper: {
    marginBottom: 4
  },
  instagramAdPreviewWrapper: {
    marginBottom: 0
  },
  adPreview: {
    width: '100%',
    maxWidth: '100%'
  },

  [`@media screen and (${smallPhonesDown})`]: {
    cardsList: {
      gridTemplateColumns: 'repeat(auto-fill, [col-start] minmax(100%, 1fr) [col-end])'
    }
  }
})

export default useStyles
